import { useEffect, useState } from "react";
import { BellRing, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { needsHomeScreen, permission, pushSupported } from "@/lib/push";
import { useReminders } from "@/components/ReminderCard";
import { useInstall } from "@/lib/pwa";

// Asked once, right after a saved log, and only in the installed app.
export function NotifPrompt() {
  const { user, setUser } = useAuth();
  const { busy, turnOn } = useReminders();
  const { installed } = useInstall();
  const [open, setOpen] = useState(false);
  const eligible = user && installed && !user.reminders_enabled && !user.notif_prompt_seen && pushSupported() && !needsHomeScreen() && permission() !== "denied";

  useEffect(() => {
    if (!eligible) return;
    const show = () => setTimeout(() => {
      setOpen(true);
      setUser((u) => ({ ...u, notif_prompt_seen: true }));
      api.put("/profile", { notif_prompt_seen: true }).catch(() => {});
    }, 1200);
    window.addEventListener("rs:logged", show);
    return () => window.removeEventListener("rs:logged", show);
  }, [eligible, setUser]);

  const yes = async () => {
    if (!(await turnOn())) return;
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="bg-[#161618] border-[#27272A] max-w-[88vw] sm:max-w-sm rounded-3xl p-6 text-center" data-testid="notif-prompt" onOpenAutoFocus={(e) => e.preventDefault()}>
        <div className="mx-auto w-14 h-14 rounded-2xl bg-[#E50914]/15 flex items-center justify-center mb-1">
          <BellRing size={26} className="text-[#E50914]" />
        </div>
        <DialogTitle className="font-display text-2xl uppercase tracking-tight">Never forget a session</DialogTitle>
        <DialogDescription className="text-[#A1A1AA] text-sm">A reminder to log your session at 2pm and 10pm your time. Turn it off anytime in Profile.</DialogDescription>
        <div className="space-y-2 mt-3">
          <button data-testid="notif-prompt-enable" onClick={yes} disabled={busy} className="btn-primary">
            {busy ? <Loader2 size={18} className="animate-spin" /> : "Turn on reminders"}
          </button>
          <button data-testid="notif-prompt-dismiss" onClick={() => setOpen(false)} className="w-full h-10 text-sm text-[#A1A1AA] hover:text-white transition-colors">Not now</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
